import CheckIcon from '@mui/icons-material/Check'
import { PopoverProps, ToggleButton, styled } from '@mui/material'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { CATEGORICAL_COLOR_PALETTE } from 'components/cell-visualizations/shared'
import DeepcellPopover from 'components/shared/DeepcellPopover'
import React, { useState } from 'react'

interface StyledToggleButtonProps {
  bgcolor: string
}

export const StyledToggleButton = styled(ToggleButton)(({ bgcolor }: StyledToggleButtonProps) => ({
  borderRadius: 0,
  '&.Mui-disabled': {
    border: 0,
    cursor: 'not-allowed',
    pointerEvents: 'auto',
  },
  '&.Mui-selected, &.Mui-selected:hover, &:hover': {
    backgroundColor: bgcolor,
  },
  width: '100%',
  height: 50,
  backgroundColor: bgcolor,
  cursor: 'pointer',
}))

interface LegendColorPickerProps {
  anchorEl: PopoverProps['anchorEl']
  onClose(selectedColor: string): void
  open?: boolean
  currentColor?: string
}
export const LegendColorPicker = ({
  anchorEl,
  onClose,
  open = false,
  currentColor = '',
}: LegendColorPickerProps): JSX.Element => {
  const [selectedColor, setSelectedColor] = useState<string>(currentColor)

  // Update selectedColor when currentColor changes (when popover opens for different items)
  React.useEffect(() => {
    setSelectedColor(currentColor)
  }, [currentColor])

  const handleColorChange = (_event: React.MouseEvent, newColor: string | null) => {
    if (newColor !== null) {
      setSelectedColor(newColor)
      onClose(newColor)
    }
  }

  return (
    <DeepcellPopover
      open={open}
      onClose={() => onClose('')}
      anchorEl={anchorEl}
      data-testid="legend-color-picker"
    >
      <ToggleButtonGroup
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(5, 52px)',
          border: '1px solid black',
        }}
        value={selectedColor}
        exclusive
        onChange={handleColorChange}
        aria-label="color-picker"
      >
        {CATEGORICAL_COLOR_PALETTE.map((item: string) => (
          <StyledToggleButton
            key={item}
            style={{
              border: `${item === selectedColor ? '2px solid white' : 'none'}`,
            }}
            bgcolor={item}
            value={item}
            aria-label={item}
            disabled={false}
          >
            {item === selectedColor ? <CheckIcon sx={{ color: 'white' }} /> : null}
          </StyledToggleButton>
        ))}
      </ToggleButtonGroup>
    </DeepcellPopover>
  )
}

export default LegendColorPicker
